import React, { useEffect } from "react";

import { Button, Modal } from "@amphore-dev/amphore-lib";
import { t } from "i18next";

import { useQueryClient } from "@tanstack/react-query";

import client, { publicClient } from "@/services/api";

import { useAuth } from "@/hooks/useAuth";

export const IdleModal: React.FC = () => {
	const [show, setShow] = React.useState(false);
	const { logout } = useAuth();
	const queryClient = useQueryClient();

	useEffect(() => {
		const clientInterceptorId = client.interceptors.response.use(
			(response) => {
				setShow(false);
				return response;
			}
		);

		const publicInterceptorId = publicClient.interceptors.response.use(
			(response) => {
				setShow(false);
				return response;
			},
			(error) => {
				const isRefreshToken =
					error.config.url === "security/refresh-token";

				if (error.response?.status === 401 && isRefreshToken) {
					queryClient.cancelQueries();
					setShow(true);
				}
				return Promise.reject(error);
			}
		);

		return () => {
			client.interceptors.response.eject(clientInterceptorId);
			publicClient.interceptors.response.eject(publicInterceptorId);
		};
	}, [queryClient]);

	const handleClose = () => {
		setShow(false);
		logout();
	};

	return (
		<Modal
			onClose={handleClose}
			closeOnOverlayClick={false}
			open={show}
			title={t("expiredSession.title")}
			size="sm"
		>
			<div className="flex flex-col gap-8">
				<p className="text-center">{t("expiredSession.message")}</p>

				<img
					src="/assets/illustrations/idle.svg"
					alt="Idle"
					className="mt-9 h-full max-h-[20vh] min-h-32 opacity-75"
				/>

				<Button onClick={handleClose} className="w-full">
					{t("auth.reconnect")}
				</Button>
			</div>
		</Modal>
	);
};
